{
  "pageTitle": "Праздники",
  "holidays": {
    "title": "Праздничные дни компании",
    "addNew": "+ Добавить праздник",
    "columns": {
      "date": "Дата",
      "name": "Название праздника",
      "actions": "Действия"
    },
    "form": {
      "titleCreate": "Новый праздник",
      "titleEdit": "Редактировать праздник",
      "dateLabel": "Дата",
      "nameLabel": "Название праздника",
      "namePlaceholder": "например, Новый год",
      "errors": {
        "dateRequired": "Укажите дату.",
        "nameRequired": "Укажите название праздника."
      }
    },
    "empty": {
      "title": "Праздников пока нет",
      "hint": "Добавьте государственные или корпоративные праздники."
    },
    "failedToLoad": "Не удалось загрузить праздники.",
    "toasts": {
      "created": "Праздник добавлен.",
      "updated": "Праздник обновлён.",
      "deleted": "Праздник удалён.",
      "saveFailed": "Не удалось сохранить праздник. Попробуйте ещё раз.",
      "deleteFailed": "Не удалось удалить праздник. Попробуйте ещё раз."
    },
    "confirm": {
      "delete": "Удалить праздник «{{name}}»?"
    },
    "import": {
      "button": "Импорт праздников РА",
      "importing": "Импорт…",
      "yearLabel": "Год импорта",
      "success": "Импортировано праздников: {{imported}}, пропущено: {{skipped}}.",
      "failed": "Не удалось импортировать праздники. Попробуйте ещё раз.",
      "invalidYear": "Укажите год от 2000 до 2100."
    }
  },
  "timeOff": {
    "title": "Отпуска сотрудников",
    "addNew": "+ Добавить отпуск",
    "columns": {
      "employee": "Сотрудник",
      "type": "Тип",
      "month": "Месяц",
      "startDate": "Начало",
      "endDate": "Конец",
      "carryover": "С прошлого года",
      "remainingDays": "Осталось дней",
      "note": "Примечание",
      "actions": "Действия"
    },
    "carryoverHint": "Включая перенос {{days}} дн. с прошлого года",
    "types": {
      "vacation": "Отпуск",
      "sick_leave": "Больничный",
      "unpaid_leave": "Отпуск без содержания",
      "business_trip": "Командировка",
      "day_off": "Выходной день"
    },
    "status": {
      "active": "В отпуске",
      "ended": "Завершён",
      "upcoming": "Не начался"
    },
    "filter": {
      "label": "Фильтр записей",
      "yearLabel": "Год",
      "all": "Все",
      "emptyTitle": "Нет подходящих записей",
      "emptyHint": "Нет отпусков, соответствующих выбранным фильтрам.",
      "allMonths": "Все месяцы",
      "allEmployees": "Все сотрудники"
    },
    "months": {
      "1": "Январь",
      "2": "Февраль",
      "3": "Март",
      "4": "Апрель",
      "5": "Май",
      "6": "Июнь",
      "7": "Июль",
      "8": "Август",
      "9": "Сентябрь",
      "10": "Октябрь",
      "11": "Ноябрь",
      "12": "Декабрь"
    },
    "form": {
      "titleCreate": "Новый отпуск",
      "titleEdit": "Редактировать отпуск",
      "employeeLabel": "Сотрудник",
      "employeePlaceholder": "Выберите сотрудника",
      "typeLabel": "Тип",
      "startDateLabel": "Дата начала",
      "endDateLabel": "Дата окончания",
      "noteLabel": "Примечание (необязательно)",
      "notePlaceholder": "Дополнительные сведения…",
      "errors": {
        "employeeRequired": "Выберите сотрудника.",
        "typeRequired": "Укажите тип.",
        "startDateRequired": "Укажите дату начала.",
        "endDateRequired": "Укажите дату окончания.",
        "endBeforeStart": "Дата окончания не может быть раньше даты начала."
      },
      "daysCount": "Итого: {{count}} дн. — день начала и день окончания включительно."
    },
    "empty": {
      "title": "Записей об отпусках нет",
      "hint": "Отслеживайте отпуска, больничные и другие отсутствия сотрудников."
    },
    "failedToLoad": "Не удалось загрузить записи об отпусках.",
    "toasts": {
      "created": "Отпуск добавлен.",
      "updated": "Отпуск обновлён.",
      "deleted": "Запись об отпуске удалена.",
      "saveFailed": "Не удалось сохранить запись об отпуске. Попробуйте ещё раз.",
      "deleteFailed": "Не удалось удалить запись об отпуске. Попробуйте ещё раз."
    },
    "confirm": {
      "delete": "Удалить эту запись об отпуске?"
    },
    "tabs": {
      "records": "Записи отпусков",
      "calc": "Расчёт отпуска"
    }
  },
  "vacationCalc": {
    "title": "Расчёт отпуска",
    "filter": {
      "label": "Фильтр строк расчёта",
      "all": "Все",
      "withCarryover": "С переносом",
      "overdrawn": "В минусе"
    },
    "columns": {
      "carryover": "Перенос",
      "annual": "Годовой лимит",
      "accrued": "Начислено на сегодня",
      "used": "Использовано",
      "unpaid": "Неоплачиваемый отпуск",
      "availableNow": "Доступно сейчас",
      "remaining": "Остаток за год"
    },
    "empty": {
      "title": "Нечего показать",
      "hint": "Нет сотрудников, подходящих под выбранный фильтр."
    },
    "explainer": "Каждому сотруднику положено {{annual}} дней отпуска в год, и они начисляются постепенно — ({{annual}} ÷ число дней в году) за каждый прошедший день, поэтому к концу января начислено ≈1.6 дня. «Доступно сейчас» = перенос + начислено на сегодня − использовано; «Остаток за год» считается от полного годового лимита. Перенос с прошлых лет вводится в карточке сотрудника. Использованными считаются только РАБОЧИЕ дни записей типа «Отпуск» — выходные по графику компании и праздники не списываются, а пересекающиеся записи не считаются дважды. Колонка «Неоплачиваемый отпуск» — только справочная и на баланс отпуска не влияет.",
    "carryoverEdit": {
      "ariaLabel": "Дни переноса",
      "saved": "Перенос сохранён.",
      "saveFailed": "Не удалось сохранить. Попробуйте ещё раз."
    }
  },
  "aria": {
    "loading": "Загрузка…",
    "deleteHoliday": "Удалить праздник",
    "editHoliday": "Редактировать праздник",
    "deleteTimeOff": "Удалить запись об отпуске",
    "editTimeOff": "Редактировать запись об отпуске"
  }
}
